import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import SettingsCellIcon from '@material-ui/icons/SettingsCell';
import SubjectIcon from '@material-ui/icons/Subject';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import Light from '../icons/light';
import CategorySectionHeader from './CategorySectionHeader';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%'
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightBold
    }
  })
);

export default function Section2() {
  const classes = useStyles();

  return (
    <Container sx={{ mb: '70px' }}>
      <CategorySectionHeader
        icon={<Light color="primary" />}
        title="Frequently Asked Questions..."
        seeMoreLink="/"
      />
      <Box className={classes.root}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>
              <strong>What do I need to be a Member of ZIMTA?</strong>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List component="nav" className={classes.root} aria-label="contacts">
              <ListItem button>
                <ListItemIcon>
                  <FingerprintIcon />
                </ListItemIcon>
                <ListItemText primary="A Valid Zimbabwean ID" />
              </ListItem>
              <ListItem button>
                <ListItemIcon>
                  <AccountBalanceIcon />
                </ListItemIcon>
                <ListItemText primary="An Active Bank Account (Where Refunds will be paid into)" />
              </ListItem>
              <ListItem button>
                <ListItemIcon>
                  <SubjectIcon />
                </ListItemIcon>
                <ListItemText primary="Be a member of the Zimbabwe Teacher's Association (ZIMTA)" />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              What do I need to quality for funeral services covered by ZIMTA?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              To quality for services, you need a valid be <strong> an active ZIMTA member</strong>,
              and should be employed by the institutions teaching in
              <strong> Zimbabwe</strong>. Pensioners should update their status when they leave
              employment to continue receiving funeral aid covered services.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              How will I get the refund for Self Payment of Services?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              All payments are made into the{' '}
              <strong>bank account that you provide at registration</strong> and you provided.
              Special arrangements for Ecocash and other methods may be made with Underwriting.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              What Information is required during the claim process?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              To claim for funeral services you paid for on your own: we need the{' '}
              <strong>burial order</strong> from the council. You should also be{' '}
              <strong>up to date with your subscriptions</strong>.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
}
